import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=36f4f906&scoped=true&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=36f4f906&prod&lang=scss&"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=36f4f906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f4f906",
  null
  
)

export default component.exports